export default "__VITE_ASSET__CmxgFge1__"